import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { RoleManagementService } from '@services/role.management.service';
import { Subject, Subscription } from 'rxjs';
import { ExamineesService } from '../services/examinees.service';
import { MessageService } from '../services/message.service';
import { AddExamineeComponent } from './add-examinee/add-examinee.component';
import { EditExamineeComponent } from './edit-examinee/edit-examinee.component';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { videoAssetGroups } from '@configs/videoTitles';


export interface examineeEditUuid {
  examineeuuId: number;
}

@Component({
  selector: 'app-examiness',
  templateUrl: './examiness.component.html',
  styleUrls: ['./examiness.component.scss']
})
export class ExaminessComponent implements OnInit, AfterViewInit {


  userServiceSubscription$: Subscription | undefined;
  userFilterServiceSubscription$: Subscription | undefined;

  displayedColumns: string[] = ['firstName',
    'lastName',
    'emailId',
    'status',
    'updated',
    // 'action'
  ];

  clientId: number;
  examineesData: any;
  examineesDataCount: any;
  firstName = "";
  lastName = "";
  emailId = "";
  status = "";
  noDataFound = false;
  messages: any;
  isNoExaminee = false;
  statusList: any;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) set content(paginator: MatPaginator) {
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  private unsubscribe: Subject<void> = new Subject<void>();
  isHidden = false;
  videoLinks: any;
  videoAssetGroups = videoAssetGroups;
  hoverVideoApiCall: boolean = false;
  constructor(
    private router: Router,
    private examineesService: ExamineesService,
    private messageService: MessageService,
    private webErrorService: WebErrorService,
    public dialog: MatDialog,
    public roleSer: RoleManagementService,
    public translate: TranslateService
  ) {

  }

  ngOnInit(): void {
    this.examineesService.getStatusList().subscribe((statusList) => { this.statusList = statusList.data;})
    this.userServiceSubscription$ = this.examineesService.getNewExamineeData.subscribe(resData => {
      this.examineesData = resData?.data;
      this.examineesDataCount = resData?.data;
      if (this.examineesData?.length == 0 || this.examineesData == undefined) {
        this.isNoExaminee = true;
      }
      else {
        this.examineesData = new MatTableDataSource(this.examineesData);
        this.examineesData.sort = this.sort;
        this.examineesData.paginator = this.paginator;
        this.isNoExaminee = false;
      }

    },
      (error) => {
        this.router.navigate(["/login"]);
      },
      () => {
      }) || undefined;

    // Examinee list start
    this.userServiceSubscription$ = this.examineesService.getExaminees()?.subscribe(resData => {
      this.examineesData = resData?.data;
      this.examineesDataCount = resData?.data;
      if (this.examineesData?.length == 0) {
        this.isNoExaminee = true;
      }
      else {
        this.examineesData = new MatTableDataSource(this.examineesData);
        this.examineesData.sort = this.sort;
        setTimeout(() => {
          this.examineesData.paginator = this.paginator;
          if(this.examineesData.paginator) {
            // ------Set translation for pagination------
            this.translate.stream([
              'examinee.pagination.pageLabel',
              'examinee.pagination.firstPage',
              'examinee.pagination.lastPage',
              'examinee.pagination.nextPage',
              'examinee.pagination.prevPage'
            ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
                this.examineesData.paginator._intl.itemsPerPageLabel = translation['examinee.pagination.pageLabel'];
                this.examineesData.paginator._intl.firstPageLabel = translation['examinee.pagination.firstPage'];
                this.examineesData.paginator._intl.lastPageLabel = translation['examinee.pagination.lastPage'];
                this.examineesData.paginator._intl.nextPageLabel = translation['examinee.pagination.nextPage'];
                this.examineesData.paginator._intl.previousPageLabel = translation['examinee.pagination.prevPage'];

                this.examineesData.paginator._intl.changes.next();
            });
          }
        });
        this.isNoExaminee = false;
      }

    },
      (error) => {
        this.router.navigate(["/login"]);
        this.webErrorService.handleAPIErrors(error);
      },
      () => {
      }) || undefined;

    // users list end



  }

  onTraningIcon(assetGroup) {
    this.isHidden = true;
    if (!this.hoverVideoApiCall) {
      this.examineesService.videoTutorial(assetGroup).subscribe(video => {
        this.videoLinks = video.data;
        this.hoverVideoApiCall = true;
      });
    }
  }

  open_in_new_window(features, link) {
    var new_window;
    if(features !== undefined && features !== '') {
      new_window = window.open('', '_blank', features);
    }
    else {
      new_window = window.open('', '_blank');
    }

    let video = '<video controls controlsList="nodownload" style="width: 100%; height: 100vh;"><source src="' + link + '" type="video/mp4" /></video>'

    if(link !== null && link !== '') {
      new_window.document.write('<!doctype html><html><head><title>Video Player</title><meta charset="UTF-8" /></head><body style="padding: 0; margin: 0;" oncontextmenu="return false">' + video + '</body></html>');
    }
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any) : void => {
      if(args.target.className != 'trainingIcon') {
        this.isHidden = false;
      }
    }
  }


  examineesFilter(): void {
    this.noDataFound = false;
    let isActive = null;
    if (this.status == 'Active') {
      let a = this.status;

      isActive = true;
    } else if (this.status == 'Inactive') {
      let a = this.status;

      isActive = false;
    } else {
      let a = ''

    }
    // const filterObj = {
    //   firstName:this.firstName,
    //   lastName:this.lastName,
    //   emailId:this.emailId,
    //   active:JSON.parse(a)
    // };

    const options = '&firstName=' + encodeURIComponent(this.firstName)
      + '&lastName=' + encodeURIComponent(this.lastName)
      + '&emailId=' + encodeURIComponent(this.emailId)
      + '&active=' + encodeURIComponent(this.status);

    this.userFilterServiceSubscription$ = this.examineesService.getExamineesFilter(options)?.subscribe(
      (resData) => {
        this.examineesData = resData?.data;
        if (this.examineesData.length < 1) {
          this.noDataFound = true;
        }
        this.examineesData = new MatTableDataSource(this.examineesData);
        this.examineesData.sort = this.sort;
        this.examineesData.paginator = this.paginator;
      },
      (error) => {
        this.isNoExaminee = true;
        this.webErrorService.handleAPIErrors(error);
        // this.router.navigate(["/login"]);

      },
      () => {
      }) || undefined;

  }
  // onChangePage(pageOfItems: Array<any>) {
  //   this.totalRecords = this.tests.length;
  // }

  // dateSort(): void {
  //   this.isItemDescended = !this.isItemDescended;
  //   this.tests.sort(this.sortdate);
  // }



  // sortdate(a: any, b: any) {
  //   //return new Date(a.updated).getTime() - new Date(b.updated).getTime();
  //   //return new Date(a.updated).getTime() - new Date(b.updated).getTime() ;
  //   return b.updated > a.updated;
  // }

  resetFilter() {

    this.firstName = "";
    this.lastName = ""
    this.emailId = "";
    this.status = "";
    this.noDataFound = false;
    this.userServiceSubscription$ = this.examineesService.getExaminees()?.subscribe(
      (resData) => {
        this.examineesData = resData?.data;
        if (this.examineesData.length < 1) {
          this.noDataFound = true;
        }
        this.examineesData = new MatTableDataSource(this.examineesData);
        this.examineesData.sort = this.sort;
        this.examineesData.paginator = this.paginator;
      },
      (error) => {
        this.router.navigate(["/login"]);
        this.webErrorService.handleAPIErrors(error);
      },
      () => {
      }) || undefined;

  }

  navigateToExamineeDetails(examineeuuid: any) {
    this.router.navigate(["examinees/editexaminee", examineeuuid]);
  }

  createNewExaminee() {
    this.router.navigate(["examinees/addexaminee"]);
  }

  addMultileExaminee() {
    if (this.roleSer.accessData && this.roleSer.accessData.insertAllowed) {
      this.router.navigate(["examinees/uploadexaminee"]);
    } else {
      return;
    }
  }

  openNewExamineeDialog(): void {
    if(this.roleSer.accessData && this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed){
      const dialogConfig: MatDialogConfig<AddExamineeComponent> = {
        minWidth: '650px',
        maxWidth: '40vw'
      };
      const dialogRef = this.dialog.open(AddExamineeComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
      });
    };
  }


  openEditExamineeDialog(examineeuuId: number): void {
    // const dialogConfig: MatDialogConfig<UserEditComponent> = {
    const dialogRef = this.dialog.open(EditExamineeComponent, {
      minWidth: '650px',
      data: {
        examineeuuId: examineeuuId
      }
    });
    // const dialogRef = this.dialog.open(UserEditComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
    });
  }


  ngOnDestroy() {
    if (this.userServiceSubscription$) {
      this.userServiceSubscription$.unsubscribe();
    }
    if (this.userFilterServiceSubscription$) {
      this.userFilterServiceSubscription$.unsubscribe();
    }

    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
